import TableHeader from "@commons/Table/TableHeader";
import Heading from "@commons/Typography/Heading";
import Text from "@commons/Typography/Text";
import { usePage } from "@hooks/usePage";
import GpsMapView from "./GpsMapView";
import GpsTableView from "./GpsTableView";
import GpsOffIcon from "@mui/icons-material/GpsOff";

type GpsEventsProps = {
  hasGPS?: boolean;
  lastLocationLongitude?: number;
  lastLocationLatitude?: number;
};

function GpsEvents({ hasGPS = false, ...props }: GpsEventsProps) {
  const { viewMode } = usePage();

  if (!hasGPS) {
    return (
      <div className="w-full bg-white flex flex-col justify-center items-center shadow-md rounded-2xl px-4 py-8">
        <div className="w-full h-48 min-h-48 lg:h-full flex flex-col items-center justify-center gap-3">
          <div className="p-4 rounded-full bg-gray-100">
            <GpsOffIcon className="text-6xl text-gray-300" />
          </div>
          <Text size="md" className="text-gray-600 font-medium">
            GPS não disponível
          </Text>
          <Text size="sm" className="text-gray-400 text-center">
            Este indivíduo não possui rastreador GPS
          </Text>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full bg-white flex flex-col justify-center items-start shadow-md rounded-2xl px-4 py-3">
      <TableHeader.Root>
        <TableHeader.MapTableSelector />
        <Heading className="text-center">
          {viewMode === "map" ? "Mapa de calor" : "Tabela de eventos do GPS"}
        </Heading>
      </TableHeader.Root>

      {viewMode === "map" ? (
        <GpsMapView
          latitude={props.lastLocationLatitude}
          longitude={props.lastLocationLongitude}
        />
      ) : (
        <GpsTableView />
      )}
    </div>
  );
}

export default GpsEvents;
